import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../constants/actionTypes';
import { Routes } from '../../../constants/routes';
import { NavigateToRouteWithDashboardParams } from '../../../helpers/routing';
import { actions as locationDashboardActions } from '../../../actions/locationDashboardActions';
import { actions as departmentActions } from '../../../actions/departmentActions';
import StatusLegend from '../../Common/StatusLegend/StatusLegend';
import GraphArc from '../../Common/GraphArc/GraphArc';
import Card from '../../Common/Card';
import Notification from '../../Common/Notification';
import StackedBarChart from '../../Common/StackedBarChart/StackedBarChart';
import Moment from 'moment';
import LineAreaGraph from '../../Common/LineAreaGraph/LineAreaGraph';
import ErrorBoundary from '../../Common/ErrorBoundary';
import './Summary.scss';
import Icon from '../../Common/Icon';
import AssignTasksDrawer from './AssignTasksDrawer';
import FollowingDepartmentsDrawer from './FollowingDepartmentsDrawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';

export class Summary extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isLoadingSummary: true,
            isLoadingDepartments: true,
            subscriptionDepartments: [],
            showBulkTaskAssignmentDrawer: false,
            showFollowDeptsDrawer: false,
            showHistGraph: this.props.isLocOpenDateTodayOrFuture,
            tasksOnScheduleGraph: {
                totalUrlParams: {
                    locationKeys: ["11111111-1111-1111-1111-111111111111"]
                },
                data: [
                    {
                        id: "Not Applicable",
                        value: 4,
                        urlParams: {
                            locationKeys: ["11111111-1111-1111-1111-111111111111"]
                        }
                    },
                    {
                        id: "Complete",
                        value: 6,
                        urlParams: {
                            locationKeys: ["11111111-1111-1111-1111-111111111111"]
                        }
                    },
                    {
                        id: "Past Due",
                        value: 1,
                        urlParams: {
                            locationKeys: ["11111111-1111-1111-1111-111111111111"]
                        }
                    },
                    {
                        id: "In Progress",
                        value: 4,
                        urlParams: {
                            locationKeys: ["11111111-1111-1111-1111-111111111111"]
                        }
                    },
                    {
                        id: "Not Due",
                        value: 2,
                        urlParams: {
                            locationKeys: ["11111111-1111-1111-1111-111111111111"]
                        }
                    }
                ]
            },
            locationTasksGraph: {},
            followingTasksGraph: {},
            assignedTasksGraph: {},
            tasksDueThisWeek: {},
            tasksPerWeek: [],
            taskHistAndProj: []
        }
    }

    componentDidMount = async () => {
        await this.loadSummary();
        await this.loadDepartments();
    }

    componentDidUpdate(prevProps) {
        // reload the summary when the user changes locations
        // they could be searching for a location so make sure there is a value
        if ((this.props.locationKey && this.props.locationKey !== prevProps.locationKey) || (this.props.followedDepartmentIds !== prevProps.followedDepartmentIds)) {
            this.loadSummary();
        }
    }

    loadSummary = async () => {
        // the user could be searching for a location and not have one selected yet
        if (this.props.locationKey === "") { return; }
        this.setState({ isLoadingSummary: true });
        try {
            const response = await this.props.locationDashboardActions.loadSummary(this.props.locationKey);
            if (response.type === types.LOAD_LOCATION_DASHBOARD_SUMMARY_SUCCESS) {

                this.setState({
                    locationTasksGraph: response.payload.locationTasksGraph,
                    followingTasksGraph: response.payload.followingTasksGraph,
                    assignedTasksGraph: response.payload.assignedTasksGraph,
                    tasksDueThisWeek: response.payload.tasksDueThisWeek,
                    tasksPerWeek: response.payload.tasksPerWeek,
                    taskHistAndProj: response.payload.historicalTaskCompletion
                })

            } else if (response.type === types.LOAD_LOCATION_DASHBOARD_SUMMARY_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingSummary: false });
        }

    }

    
    loadDepartments = async () => {

        this.setState({ isLoadingDepartments: true });
        try {
            const requestParams = {
                isActive: true,
                subscriptionId: this.props.subscriptionId,
                pageSize: 1000
            };

            const response = await this.props.departmentActions.searchDepartments(requestParams);
            if (response.type === types.SEARCH_DEPARTMENT_SUCCESS) {
                this.setState({
                    subscriptionDepartments: response.payload.results
                });
            } else if (response.type === types.SEARCH_DEPARTMENT_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoadingDepartments: false });
        }            

    }

    onClick_TasksAssignedToMe = (urlParams) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
    }

    onClick_TasksFollowed = (urlParams) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
    }

    onClick_LocationTasks = (urlParams) => {
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
    }

    onClick_TasksDueThisWeek = (urlParams) => {
        // the urlparams for start/end will be set when clicking on the graph, but not on the label
        if(!urlParams.targetDateEnd && !urlParams.targetDateStart){
            urlParams.targetDateStart = [Moment().day(0).format("YYYY-MM-DD")];
            urlParams.targetDateEnd = [Moment().day(7).format("YYYY-MM-DD")];
        }
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
    }

    onClick_TasksPerWeek = (data) => {
        const urlParams = {
            locationKeys: [this.props.locationKey],
            targetDateStart: [Moment(data.targetDateStart).format("YYYY-MM-DD")],
            targetDateEnd: [Moment(data.targetDateEnd).format("YYYY-MM-DD")]
        };
        NavigateToRouteWithDashboardParams(Routes.Tasks, urlParams, false);
    }

    onOpenBulkTaskAssignmentDrawer = () => {
        this.setState({ showBulkTaskAssignmentDrawer: true });
    }

    onBulkAssignComplete = () => {
        this.setState({ showBulkTaskAssignmentDrawer: false }, this.loadSummary);
    }

    onBulkAssignCancel = () => {
        this.setState({ showBulkTaskAssignmentDrawer: false });
    }

    onOpenFavDeptsDrawer = () => {
        this.setState({ showFollowDeptsDrawer: true });
    }

    onFollowDeptsComplete = (newDepartmentIds) => {
        this.setState({ showFollowDeptsDrawer: false });
        this.props.updateFollowedDepartmentIds(newDepartmentIds);
    }

    onFollowDeptsCancel = () => {
        this.setState({ showFollowDeptsDrawer: false });
    }

    getDepartmentCardTitle = () => {

        if(this.props.followedDepartmentIds.length === 0){
            return "No Followed Departments";
        } else if(this.props.followedDepartmentIds.length <= 2){
            // display all names if there are only 1 or 2 followed departments
            let retval = "tasks in";
            for(let i = 0; i < this.props.followedDepartmentIds.length; i++){
                if(i > 0){
                    retval += ",";
                }
                retval += " " + this.state.subscriptionDepartments.find(m => m.id == this.props.followedDepartmentIds[i]).name;
            }
            return retval;

        } else {
            return "Tasks in your " + this.props.followedDepartmentIds.length + " departments";
        }
    }

    render() {

        const barGraphWidth = (this.props.isMobile) ? 310 : 
            (this.state.showHistGraph === true ? 600 : 1330);

        const lineAreaGraphClass = this.state.showHistGraph === true ? "col-md-6 full-card" : "col-md-12 full-card";

        const LineAreaGraphTooltip = (args) => {
            
            if (args.active) {
                return (
                    <div className="custom-tooltip">
                        <div className="line-area-title">Percent Remaining</div>
                        {args.payload && args.payload.map(item => 
                            <div 
                                key={item.dataKey} 
                                className="line-area-label"
                                style={ { color: item.stroke } }>
                                
                                {item.dataKey.charAt(0).toUpperCase() + item.dataKey.slice(1)}: {item.payload[item.dataKey]}%
                                
                            </div>
                        )}
                    </div>
                );
            }

            return null;
        };

        const lineAreaGraphTitle = 
        <div className='hist-graph-title'>
            PERCENT HISTORICAL TASK COMPLETION
            <span className="status-key historical"></span>
            AND FORECAST COMPLETION
            <span className="status-key projected"></span>
        </div>;

        const isLoadingAnything = (this.state.isLoadingDepartments || this.state.isLoadingSummary) ? true : false;
        
        return (
            <div className='summary-widget'>
                <div className="row">
                    <div className="col-12">
                        <div className="dashboard-widget-title">Summary</div>
                        <div className="float-end">
                            <StatusLegend />
                        </div>
                    </div>
                </div>
                <LoadingIndicator isLoading={isLoadingAnything}>
                    <Fragment>
                        {this.state.isLoadingSummary === false && this.state.isLoadingDepartments === false &&
                            <Fragment>
                            <div className="row mt-2">
                                <div className="col-md-3 col-sm-6 quarter-card mb-3">
                                    <Card>
                                        <GraphArc title="Tasks due this week"
                                            data={this.state.tasksDueThisWeek.data}
                                            totalUrlParams={this.state.tasksDueThisWeek.totalUrlParams}
                                            onClick={this.onClick_TasksDueThisWeek}
                                        />
                                    </Card>
                                </div>
                                <div className="col-md-3 col-sm-6 quarter-card mb-3">
                                    <Card>
                                        <GraphArc title="Location Tasks" 
                                            data={this.state.locationTasksGraph.data}
                                            totalUrlParams={this.state.locationTasksGraph.totalUrlParams}
                                            onClick={this.onClick_LocationTasks}
                                        />
                                    </Card>
                                </div>
                                <div className="col-md-3 col-sm-6 quarter-card mb-3">
                                    <Card>
                                        <GraphArc title={this.getDepartmentCardTitle()}
                                            data={this.state.followingTasksGraph.data}
                                            totalUrlParams={this.state.followingTasksGraph.totalUrlParams}
                                            onClick={this.onClick_TasksFollowed}
                                        />
                                        <div className="text-end cog" onClick={this.onOpenFavDeptsDrawer}>
                                            <Icon name="cog" />
                                        </div>                                    
                                    </Card>
                                </div>
                                <div className="col-md-3 col-sm-6 quarter-card">
                                    <Card>
                                        <GraphArc title="Tasks assigned to me"
                                            data={this.state.assignedTasksGraph.data}
                                            totalUrlParams={this.state.assignedTasksGraph.totalUrlParams}
                                            onClick={this.onClick_TasksAssignedToMe}
                                        />
                                        <div className="text-end cog" onClick={this.onOpenBulkTaskAssignmentDrawer}>
                                            <Icon name="cog" />
                                        </div>                                        
                                    </Card>
                                </div>
                            </div>

                            <div className="row mt-3">
                            
                                <div className={lineAreaGraphClass}>
                                    <Card>
                                        <StackedBarChart 
                                            title="Tasks Per week"
                                            data={this.state.tasksPerWeek}
                                            width={barGraphWidth}
                                            onClick={this.onClick_TasksPerWeek}
                                        />
                                    </Card>
                                </div>

                                {this.state.showHistGraph === true &&
                                    <div className="col-md-6 full-card">
                                        <Card>
                                            <ErrorBoundary shouldSwallow={true}>
                                                <LineAreaGraph
                                                    title={lineAreaGraphTitle}
                                                    width={barGraphWidth}
                                                    data={this.state.taskHistAndProj}
                                                    tooltip={<LineAreaGraphTooltip/>} />
                                            </ErrorBoundary>
                                            <div className="help text-end" >
                                                <a 
                                                href="https://ehsolution.zendesk.com/hc/en-us/articles/360033381974-How-do-I-read-and-interpret-the-Percent-Historical-Completion-graph" 
                                                target="_blank" 
                                                rel="noopener noreferrer">
                                                    <div className='icon-area'>
                                                        <Icon name="question-circle-o" /> Help
                                                    </div>
                                                </a>
                                            </div>
                                        </Card>
                                    </div>
                                }

                            </div>
                            </Fragment>
                        }
                    </Fragment>
                </LoadingIndicator>
                { this.state.showBulkTaskAssignmentDrawer &&
                    <AssignTasksDrawer
                        locationKey={this.props.locationKey}
                        locationDashboardActions={this.props.locationDashboardActions}
                        onComplete={this.onBulkAssignComplete}
                        onCancel={this.onBulkAssignCancel}
                    />
                }
                { 
                    this.state.showFollowDeptsDrawer &&
                    <FollowingDepartmentsDrawer
                        locationKey={this.props.locationKey}
                        locationDashboardActions={this.props.locationDashboardActions}
                        onComplete={this.onFollowDeptsComplete}
                        onCancel={this.onFollowDeptsCancel}
                        followedDepartmentIds={this.props.followedDepartmentIds}
                        subscriptionDepartments={this.state.subscriptionDepartments}
                        user={this.props.user}
                        subscriptionId={this.props.subscriptionId}
                        departmentActions={this.props.departmentActions}
                    />                    
                }
            </div>
        )
    }
}

Summary.propTypes = {
    windowWidth: PropTypes.number.isRequired,
    locationKey: PropTypes.string, // not required - user could be searching for a location
    isLocOpenDateTodayOrFuture: PropTypes.bool.isRequired,
    followedDepartmentIds: PropTypes.array,
    updateFollowedDepartmentIds: PropTypes.func.isRequired,
    locationDashboardActions: PropTypes.object.isRequired,
    departmentActions: PropTypes.object.isRequired,
    user: PropTypes.object,
    isMobile: PropTypes.bool.isRequired,
    subscriptionId: PropTypes.string.isRequired
};
function mapStateToProps(state) {
    return {
        windowWidth: state.window.width,
        user: state.user
    };
}
function mapDispatchToProps(dispatch) {
    return {
        locationDashboardActions: bindActionCreators(locationDashboardActions, dispatch),
        departmentActions: bindActionCreators(departmentActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Summary);